import { WidgetOption, WidgetType } from '@/types'
import checkboxGroup from '../checkbox-group'

/** 单选框 */
export default {
  ...checkboxGroup,
  key: 'radio-group',
  name: '单选框',
  type: WidgetType.RADIO_GROUP,
  icon: 'fa-icon-widget-radio',
  height: 64
} as WidgetOption
